/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_Budget_AInputs */

const en_mk_faq_budget_a = /** @type {(inputs: Mk_Faq_Budget_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage figures depend on provider reports. Token and cost thresholds stop subsequent assignments; requests already running may exceed them. Some agent subscriptions do not report monetary costs, so that information is shown as unknown. You can also set team size and a deadline.`)
};

const id_mk_faq_budget_a = /** @type {(inputs: Mk_Faq_Budget_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angka pemakaian mengikuti laporan provider. Ambang token dan biaya menghentikan penugasan berikutnya; permintaan yang sedang berjalan bisa melampauinya. Sebagian langganan agent tidak melaporkan biaya uang, sehingga informasi tersebut ditampilkan sebagai tidak diketahui. Atur juga jumlah agent dan batas waktu kerja.`)
};

/**
* | output |
* | --- |
* | "Usage figures depend on provider reports. Token and cost thresholds stop subsequent assignments; requests already running may exceed them. Some agent subscri..." |
*
* @param {Mk_Faq_Budget_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_budget_a = /** @type {((inputs?: Mk_Faq_Budget_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_Budget_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_budget_a(inputs)
	return en_mk_faq_budget_a(inputs)
});